import { Plot } from "@abaco/portal-global-state/src/modules/global-state/models/Plot";
import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import {
    CompleteActivityExecution,
    DisplayExecution,
    EquipmentResource,
    FormActionExecutionStep,
    ProvExecutionOut,
    UnitOfMeasure,
    WaterItem,
    WaterSelected
} from "./models/ActivityExecution";
import { Phytochemical, PhytochemicalAction } from "./models/Phytochemical";
import { BrgHeader, BrgType, Phenology, ViolationItem } from "./models/TreatmentModel";
import { ActivityExecution } from "./models/ActivityExecution";
import { WorkerData } from "./models/Worker";
import { Activity, ActivityFormData, ActivityTypeCode, Block } from "./models/Activity";
import { FertilizerAction } from "./models/Fertilizer";
import { Action } from "./models/Action";
import { WaterOut } from "./models/Water";
import { DatepickerWeather } from "./models/Weather";
import { EquipmentData } from "./models/Equipment";
import { Irrigation } from "./models/Irrigation";
import { Seed, SeedAction } from "./models/Seed";
import { Block as GlobalBlock } from "@abaco/portal-global-state/src/modules/global-state/models/Block";
import { Worker } from "./models/Worker";

export default class TreatmentVuexModule extends AbacoVuexModule {
    @State({ default: [] }) plots!: Plot[];
    @State({ default: null }) treatmentDraftHeader!: BrgHeader | null;
    @State({ default: false }) isBulkCreationModeEnabled!: boolean;
    @State() selectedActivityType!: ActivityTypeCode;
    @State() selectedActivityTypeDescription!: string | null;
    @State() canSelectWarehouse!: boolean;

    //creazione dell'attività
    @State() selectedPlot!: Plot | null;
    @State() dataActionStep!: FormActionExecutionStep | null;
    @State() newActivityExecutionCurStep!: number | null;
    @State() selectedPhenology!: Phenology | null;
    @State() curWaterSelected!: WaterSelected | null;
    @State() curPhytochemical!: Phytochemical | null;

    @State({ default: [] }) selectedPlots!: Plot[];
    @State({ default: [] }) selectedBlocks!: Block[];

    @State({ default: {} }) unitOfMeasures!: { [family_name: string]: UnitOfMeasure[] };
    @State({ default: null }) currentActivityExecution!: ActivityExecution;
    @State({ default: null }) executionList!: CompleteActivityExecution[];
    @State({ default: null }) newlyAddedExes!: CompleteActivityExecution[];
    @State({ default: [] }) executionsTypeList!: Activity[] | [];

    @State({ default: null }) curPhyto!: PhytochemicalAction | null;
    @State({ default: false }) isEditingTreatmentDraftHeader!: boolean;
    @State({ default: false }) registerModificationMode!: boolean;
    @State() selectedCompleteExecution!: DisplayExecution;
    @State() uomMod!: UnitOfMeasure[];
    @State() workerSelected!: Worker;
    @State() workers!: WorkerData[];
    @State() validationResult!: ViolationItem[];
    @State({ default: [] }) waterItems: WaterItem[] = [];
    @State({ default: [] }) lastSavedExecutions: number[] = [];
    @State({ default: false }) isExecutionEdit!: boolean;
    @State({ default: false }) clickBack!: boolean;

    //fertilization stepper
    @State({ default: [] }) actionFertilizers!: FertilizerAction[];
    @State() editingActivity!: Activity | null;
    @State() editingAction!: Action | null;
    @State() curActivityWater!: WaterOut | null;
    @State() curWeatherWidgetData!: DatepickerWeather | null;
    @State({ default: 0 }) resetCacheWarehouse!: number;

    @State() allActivityType!: any;
    @State() actualRegisterType!: string; //Register type selected by the user

    //phytochemical
    @State({ default: [] }) phytochemicals!: PhytochemicalAction[];
    @State() isProtocol!: boolean;
    @State() formData!: ActivityFormData | null;
    @State() selectedActivities!: Activity[];
    @State() currentCampaign!: number;

    //equipaggiament
    @State({ default: [] }) equipments!: EquipmentData[];

    //Irrigation
    @State() curIrrigation!: Irrigation | null;
    @State() validIrrigation!: boolean;
    @State() calcWithDuration!: boolean;
    @State() volumeUom: UnitOfMeasure[] = [];
    @State() selectedRegisterType!: BrgType;

    //User permissions
    @State({ default: false }) readProfile!: boolean;
    @State({ default: false }) editProfile!: boolean;

    //seed Activity
    @State() curSeed!: Seed | null;
    @State({ default: false }) validSeed!: boolean;
    @State() curActionSeed!: SeedAction | null;

    //Copy and move executions function
    @State() selectedExeList: ProvExecutionOut[] = [];
    @State() draftHeadersList!: BrgHeader[];

    @State() brgTypes!: BrgType[];

    @State() isConfigurationValid!: boolean; //True if the registry configuration is valid (backend side), false otherwise. A valid configuration has at least one activity type

    // Caching resources
    @State({ default: [] }) cachedPlots!: Plot[];
    @State({ default: [] }) cachedBlocks!: GlobalBlock[];
    @State({ default: [] }) cachedWorkers!: Worker[];
    @State({ default: [] }) cachedEquipments!: EquipmentResource[];
}
